class Dropdown {
    constructor(element) {
        this.el = $(element).attr('tabindex', '-1');
        this.button = this.el.children('button').attr('aria-haspopup', 'true');
        this.dropdown = this.button.next();
        this.el.on('mouseenter', this.open.bind(this));
        this.el.on('mouseleave', this.close.bind(this));
        this.close();
        if (this.dropdown.attr('id')) this.button.attr('aria-owns', this.dropdown.attr('id'));
    }
    open() {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.button.attr('aria-expanded', 'true');
        this.dropdown.attr('aria-hidden', 'false');
    }
    close() {
        let self = this;
        if (self.closeTimer) clearTimeout(self.closeTimer);
        self.closeTimer = setTimeout(() => {
            self.button.attr('aria-expanded', 'false');
            self.dropdown.attr('aria-hidden', 'true');
        }, 250);
    }
}

$('.dropdown').each((i, el) => {
    new Dropdown(el);
});
